import Toggles from '@domain/toggles/Toggles'

/**
 * DV-6394 — Expone identificadores first-party en el dataLayer tras un registro
 * exitoso, para que GTM los reenvíe a las plataformas de anuncios (Meta, Google,
 * Pinterest, TikTok). No bloqueante y solo con consentimiento de marketing.
 *
 * El push se hace SOLO si:
 *  - el toggle `firstPartyDataLayer` está activo, y
 *  - el usuario aceptó cookies de marketing (Cookiebot).
 *
 * Nombres de variables EXACTOS: GTM los espera literalmente. `user_email` va en
 * claro (el hashing SHA-256 lo hace GTM). `event_id` es único por registro para
 * deduplicar navegador/CAPI.
 *
 * @param {{ email?: string, userId?: number|string, country?: string, profession?: string }} payload
 */
export const pushSignupComplete = (payload = {}) => {
	if (!Toggles.isEnabled('firstPartyDataLayer')) {
		return
	}

	const { email, userId } = payload
	if (!email || userId === undefined || userId === null) {
		return
	}

	if (!window.Cookiebot?.consent?.marketing) {
		return
	}

	const externalId = String(userId)
	const event = {
		event: 'signup_complete',
		user_email: email,
		external_id: externalId,
		event_id: `signup_${externalId}`
	}

	if (payload.country) {
		event.user_country = String(payload.country)
	}
	if (payload.profession) {
		event.professional_profile = String(payload.profession)
	}

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(event)
}

export default pushSignupComplete
